import { initializeSentry } from 'js/utils/initializeSentry';

initializeSentry();
